export default {
  relaunchAutoIndex: 'Relancer l\'indexation automatique'
}